var _style, _defs, _defs2, _defs3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDetectionicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 89.5 88.4",
    style: {
      enableBackground: "new 0 0 89.5 88.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.753;enable-background:new    ;}\n\t.st1{clip-path:url(#SVGID_00000164475823597261242870000008212176029815479199_);}\n\t.st2{clip-path:url(#SVGID_00000094597969521495424900000016021706438071627427_);}\n\t.st3{clip-path:url(#SVGID_00000068647410172273875750000001827599949293077660_);fill:#55BBB1;}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 16,
    y: 16,
    width: 58,
    height: 58
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150092038661881979480000011157828067710594711_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000150092038661881979480000011157828067710594711_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000038384987285300568870000011315489132861320111_",
    d: "M45,56.1c6.1,0,11.1-5,11.1-11.1 c0-6.1-5-11.1-11.1-11.1c-6.1,0-11.1,5-11.1,11.1C33.9,51.1,38.9,56.1,45,56.1z M45,59.5c-8,0-14.5-6.5-14.5-14.5 S37,30.5,45,30.5S59.5,37,59.5,45S53,59.5,45,59.5z M70.6,70.6V60.3c0-0.9,0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7v11.9 c0,0.9-0.8,1.7-1.7,1.7H60.4c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7L70.6,70.6z M19.4,70.6h10.2c0.9,0,1.7,0.8,1.7,1.7 c0,0.9-0.8,1.7-1.7,1.7H17.7c-0.9,0-1.7-0.8-1.7-1.7V60.3c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7L19.4,70.6z M70.6,19.4 H60.4c-0.9,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7h11.9c0.9,0,1.7,0.8,1.7,1.7v11.9c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7 L70.6,19.4z M19.4,19.4v10.2c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7V17.7c0-0.9,0.8-1.7,1.7-1.7h11.9 c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7L19.4,19.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047051502947774273220000012997726619299340711_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000038384987285300568870000011315489132861320111_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000047051502947774273220000012997726619299340711_)"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000003812871285922671930000017031610323815100551_",
    x: -1,
    y: -1,
    width: 92,
    height: 92
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085967326981190951880000009662007844586854814_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003812871285922671930000017031610323815100551_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    style: {
      clipPath: "url(#SVGID_00000085967326981190951880000009662007844586854814_)",
      fill: "#55BBB1"
    },
    width: 60,
    height: 60
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetectionicon);
export default __webpack_public_path__ + "static/media/detectionicon.974b12249e5fdbf87f4759c1771fe4b8.svg";
export { ForwardRef as ReactComponent };